import { Box, Button, Flex, VStack } from "@chakra-ui/react";
import iconUserAvatarList from "assets/icons/icon-user-avatar-list.svg";
import CompanyHeader from "components/ui/CompanyHeader";
import CustomCheckBox from "features/companies/components/CustomCheckBox";
import { useResourceList, useResourceListProps } from "hooks/useResourceList";
import { useFormContext } from "react-hook-form";

interface Props {
  companyIds?: string[];
}

export default function RecipientsByCompanies({ companyIds }: Props) {
  const options: useResourceListProps = {
    resourceName: "companies",
    path: "companies/with-recipients",
  };

  console.log("companyIds", companyIds);

  if (companyIds) options.params = { companyIds };

  const { data: companies } = useResourceList(options);

  const { setValue, watch } = useFormContext();

  const recipients = watch("recipients") || [];

  const onSelectAll = (company: any) => {
    const companyRecipientIds = company.recipients.map((item) => item.id);
    const newItems = [
      ...new Set([...(recipients || []), ...companyRecipientIds]),
    ];
    setValue("recipients", newItems, { shouldValidate: true });
  };

  if (!companies) return null;

  return (
    <VStack mt="20px" spacing="20px" pb="100px" w="full">
      {companies.map((company) => (
        <Box
          key={`company-${company.id}`}
          w="full"
          borderRadius="10px"
          border="1px solid rgba(0, 0, 0, 0.10)"
          bgColor="white"
          padding="30px"
        >
          <Flex>
            <CompanyHeader
              company={company}
              description={`${company?.recipients?.length} membros`}
            />
            {company?.recipients?.length > 0 && (
              <Button
                size="sm"
                ml="auto"
                borderColor="#61A318"
                color="#61A318"
                onClick={() => onSelectAll(company)}
              >
                Selecionar todos
              </Button>
            )}
          </Flex>

          <Box mt="20px" ml="10px">
            {company?.recipients &&
              company.recipients.map((recipient) => (
                <CustomCheckBox
                  key={`recipient-${recipient.id}`}
                  py="13px"
                  image={iconUserAvatarList}
                  value={recipient.id}
                  isChecked={recipients.includes(recipient.id)}
                  label={recipient.name}
                  description={recipient.email}
                  onChange={(e) => {
                    const newItems = e.target.checked
                      ? [...recipients, e.target.value]
                      : [
                          ...recipients.filter(
                            (item) => item !== e.target.value
                          ),
                        ];
                    setValue("recipients", newItems, { shouldValidate: true });
                  }}
                />
              ))}
          </Box>
        </Box>
      ))}
    </VStack>
  );
}
